<input
  type="text"
  class="inline-edit--field op-input"
  (click)="onInputClick($event)"
  [value]="dates"
  (focus)="onInputFocused()"
/>
